import React, { useEffect, useRef, useState } from "react";
import './App.css';
import AllRoutes from './AllRoutes';
import './components/museo_font/stylesheet.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'rsuite/dist/rsuite.min.css';

// import "react-toastify/dist/ReactToastify.css"; // Loaded via CDN in public/index.html to bypass PurgeCSS
import { ToastContainer, toast } from 'react-toastify';
import { GlobalStyles } from "./GlobalStyles";
import { ThemeProvider } from "styled-components";
import Metadata from './layout/Others/Metadata';
import { defaultDarkTheme, defaultLightTheme } from './components/CommonMethod/CommonMethods';
import { useMyContext } from './components/Provider/CommonProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import { setItem } from './Utils/localStorageUtils';
import { siteThemApi } from './components/CommonApis/CommonApiUrl';
import { useDispatch } from 'react-redux';
import axios from "axios";
import { getBannerInfo } from './component/Commonmethod/bannerUtils';
import { useSelector } from 'react-redux';

function App() {
  const { themeMode, fetchRequest, organisationDetails, saveOrganisationDetails, fetchOrganisationDetails, siteMetadata, fetchSiteMetadata, accessToken, checkBandwidthRestriction, bandwidthRestricted } = useMyContext();

  // Stable ref so axios interceptors (stale closures) always read the current value
  const bandwidthRestrictedRef = useRef(false);
  useEffect(() => {
    bandwidthRestrictedRef.current = bandwidthRestricted;
  }, [bandwidthRestricted]);
  // const access_token = localStorage.getItem("access_token");

  const baseURL = process.env.REACT_APP_Baseurl
  const storageApi = `${baseURL}/admin/storage_index`
  const dispatch = useDispatch()
  const location = useLocation()

  const navigate = useNavigate(); // Add this inside your component
  const [serviceError503, setServiceError503] = useState(false);
  const [serviceOfflineModal503, setServiceOfflineModal503] = useState(false);
  const [serviceError500, setServiceError500] = useState(false);

  const ServiceErrorModal503 = ({ show }) => {
    if (!show) return null;

    return (
      <div className="modalBackdropdataserviceunavailable">
        <div className="modalContentdataserviceunavailable ">
          <h2>Service Unavailable</h2>
          <p>The server is temporarily unavailable. Please contact support or try again later.</p>
        </div>
      </div>
    );
  };

  const ServiceOfflineModal503 = ({ show }) => {
    if (!show) return null;

    return (
      <div className="modalBackdropdataserviceunavailable">
        <div className="modalContentdataserviceunavailable ">
          <h2>You're offline</h2>
          <p>The internet is not available. Please try again later {" "}


            <a
              href="/"
              onClick={(e) => {
                window.location.href = "/"; // ✅ Manual redirect
              }}
              className="theme-bg-color-secondary"
            >
              Retry
            </a>.
          </p>
        </div>


      </div>
    );
  };



  const [counter, setCounter] = useState(5); // Countdown timer
  const timerStarted = useRef(false); // To avoid multiple intervals

  const ServiceErrorModal500 = ({ show }) => {
    if (show && !timerStarted.current) {
      timerStarted.current = true;

      const interval = setInterval(() => {
        setCounter((prev) => {
          if (prev === 1) {
            clearInterval(interval);
            window.location.href = "/"; // Redirect
          }
          return prev - 1;
        });
      }, 1000);
    }

    if (!show) return null;

    return (
      <div className="modalBackdropdataserviceunavailable ">
        <div className="modalContentdataserviceunavailable">
          <div className="col-lg-12 row justify-content-center theme-text-color ">
            <div className="col-lg-3">
              <div className="text-center">
                <h1 className="theme-button-bg-color counter_timing">{counter}</h1>
              </div>
            </div>
          </div>
          <h5>Your page is not working as expected, please wait for a while</h5>
          <p
            className="theme-button-bg-color" >
            Try again Later. If not redirected,{" "}
            <a
              onClick={(e) => {
                e.preventDefault(); // prevent default anchor behavior
                window.location.reload();// ✅ Manual redirect
              }}
              className="theme-button-bg-color"
            >
              Click Here
            </a>.
          </p>
        </div>
      </div>
    );
  };

  let sessionExpired = false;

  useEffect(() => {
    // ── REQUEST interceptor ──────────────────────────────────────────────────
    // When bandwidth is already restricted, silently cancel every outgoing
    // request EXCEPT /bandwidth-status (needed for the Re-check button).
    // This stops the server from being hammered with 403s and prevents the
    // checkBandwidthRestriction → 403 → checkBandwidthRestriction loop.
    const reqInterceptor = axios.interceptors.request.use((config) => {
      if (
        bandwidthRestrictedRef.current &&
        !config.url?.includes('/bandwidth-status')
      ) {
        return Promise.reject({ isBandwidthBlock: true, config });
      }
      return config;
    });

    // ── RESPONSE interceptor ─────────────────────────────────────────────────
    const interceptor = axios.interceptors.response.use(
      (res) => res,
      (err) => {
        // Silently swallow requests cancelled by the request interceptor above
        if (err?.isBandwidthBlock) return Promise.reject(err);

        const status = err.response?.status;

        if ([401, 403].includes(status)) {
          // Bandwidth restriction — show modal on the current page, no redirect.
          // Guard: only trigger checkBandwidthRestriction once (ref prevents
          // duplicate calls from concurrent 403 responses).
          if (err.response?.data?.code === 'BANDWIDTH_LIMIT_REACHED') {
            if (!bandwidthRestrictedRef.current) {
              bandwidthRestrictedRef.current = true; // set immediately, before the async call
              checkBandwidthRestriction();
            }
            return Promise.reject(err);
          }

          if (!sessionExpired) {
            // Check if current URL is partner-related or unified player route
            const currentPath = window.location.pathname;
            const isPartnerRoute = currentPath.includes('/partner') || currentPath.includes('/channel');
            const isUnifiedPlayerRoute = currentPath.includes('/nexs-player');

            if (isPartnerRoute || isUnifiedPlayerRoute) {
              // console.log('401/403 error on partner/unified-player route, showing toast instead of clearing localStorage');
              if (isUnifiedPlayerRoute) {
                // For unified player, don't show error toast - let the component handle it
                console.log('Authentication error on unified player route - component will handle');
              } else {
                toast.error("Authentication failed. Please check your credentials.");
              }
              return Promise.reject(err);
            }

            sessionExpired = true;

            let savedLocation = localStorage.getItem("location");
            const userRole = localStorage.getItem("role");

            try {
              if (savedLocation?.startsWith('"')) {
                savedLocation = JSON.parse(savedLocation);
              }
            } catch {
              savedLocation = "/";
            }

            // console.log('Session expired, clearing localStorage and redirecting...');
            // console.log('Current location:', window.location.pathname);
            // console.log('User role before clear:', userRole);

            // 💾 Keep location only
            localStorage.clear();
            if (savedLocation) {
              localStorage.setItem("location", savedLocation);
            }

            // Determine which login page to redirect to based on previous user role
            let loginPath = "/login"; // Default admin login
            if (userRole === "4") {
              loginPath = "/partner"; // Only partner role should go to partner login
            }

            // console.log('Redirecting to login page:', loginPath);
            // toast.error("Session expired. Please log in again.");

            requestAnimationFrame(() => {
              navigate(loginPath, { replace: true });
            });
          }
        } else if (status === 503) {
          setServiceError503(true);
        } else if (!navigator.onLine) {
          // 📴 Internet is disconnected
          // toast.error("You are offline. Please check your connection.");
          setServiceOfflineModal503(true); // Or create a separate state like setOfflineError(true)
        } else if (!err.response || err.code === "ECONNABORTED") {
          // 🌐 API unreachable or timed out
          // toast.error("Service is unavailable. Please try again later.");
          setServiceError503(true);
        }

        return Promise.reject(err);
      }
    );

    return () => {
      axios.interceptors.request.eject(reqInterceptor);
      axios.interceptors.response.eject(interceptor);
    };
  }, []);


  const handleorganisationDetails = async () => {
    try {
      const response = await organisationDetails();
      if (response) {
        await saveOrganisationDetails(response);
      }
    } catch (error) {
      console.error("Error fetching organisation details:", error);
    }
  };


  useEffect(() => {
    const initApp = () => {
      // Run critical metadata fetches in the background so the shell can paint sooner.
      Promise.allSettled([
        organisationDetails().then(res => res && saveOrganisationDetails(res)),
        fetchSiteMetadata(),
        checkBandwidthRestriction(),
      ]).catch(() => { });

      if (accessToken) {
        setTimeout(() => {
          fetchRequest({
            method: 'GET',
            url: `${siteThemApi}`,
            params: {},
            data: {},
          }).then(themeResponse => {
            if (themeResponse?.status) {
              dispatch({ type: "GET_SITE_THEME_BACKEND", payload: themeResponse });
            }
          }).catch(() => { });
        }, 800);
      }
    };

    initApp();
  }, [accessToken]);


  useEffect(() => {
    if (window.location.pathname !== "/") {
      setItem('location', window.location.pathname);
    }
  }, [location])

  // Client-side canonical URL enforcement for any domain
  useEffect(() => {
    const currentHost = window.location.hostname.toLowerCase();
    const currentProtocol = window.location.protocol;
    const currentUrl = window.location.href;

    // Skip redirect for ALL localhost variations and IP addresses (development)
    if (currentHost.includes('localhost') ||
      currentHost === '127.0.0.1' ||
      /^\d+\.\d+\.\d+\.\d+/.test(currentHost) ||
      currentHost === 'www.localhost') {
      console.log('[Canonical Redirect] Skipping redirect for development host:', currentHost);
      return;
    }

    // Apply to any domain (not just specific domains)
    const bareHost = currentHost.replace(/^www\./i, '');  // remove leading www.
    if (bareHost && bareHost.length > 0) {
      const isWww = /^www\./i.test(currentHost);
      const isHttps = currentProtocol === 'https:';

      // Redirect if: www present OR protocol is not https
      if (isWww || !isHttps) {
        const targetUrl = `https://${bareHost}${window.location.pathname}${window.location.search}${window.location.hash}`;
        console.log('[Canonical Redirect] Redirecting from', currentUrl, 'to', targetUrl);

        // Use window.location.replace for a clean redirect (no history entry)
        window.location.replace(targetUrl);
        return; // Stop further execution
      }
    }
  }, []); // Run only once on mount // Run only once on mount // Run only once on mount

  useEffect(() => {
    const fetchStorage = async () => {
      if (!accessToken) return;

      try {
        const responseStorage = await fetchRequest({
          method: 'GET',
          url: `${storageApi}`,
          params: {},
          data: {},
        });

        if (responseStorage?.status) {
          dispatch({ type: "GET_STORAGE", payload: responseStorage });
        }
      } catch (error) {
        dispatch({
          type: "GET_STORAGE_FAILED",
          payload: error?.response?.data?.message || error?.response?.data?.error || error?.message,
        });
      }
    };
    const timer = setTimeout(fetchStorage, 1200);
    return () => clearTimeout(timer);
  }, []);


  const { displayDate, showBanner: timeBanner } = getBannerInfo();
  const maintenanceEnabled = useSelector(state => Number(state?.siteTheme?.siteTheme?.maintenance_banner_enabled) === 1 || Number(siteMetadata?.maintenance_banner_enabled) === 1);
  const showBanner = maintenanceEnabled && timeBanner;

  return (
    <>
      <Metadata />

      <div className="min-h-screen bg-gray-50 notificationofwednesday">
        {showBanner && (
          <div className="max-w-6xl mx-auto px-2 py-2 text-center text-sm md:text-base font-medium">
            We’re performing Planned essential code updates to improve performance
            by <strong>{displayDate} on 10 am to 4 pm (IST)</strong>. The service will resume shortly.
            Thanks for your understanding. </div>
        )}
      </div>

      {/* <ServiceErrorModal503 show={serviceError503} />
      <ServiceErrorModal500 show={serviceError500} />
      <ServiceOfflineModal503 show={serviceOfflineModal503} /> */}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" style={{ zIndex: 1000000 }} />
      <ThemeProvider theme={themeMode ? defaultDarkTheme : defaultLightTheme}>
        <GlobalStyles />
        <AllRoutes />
      </ThemeProvider>
    </>
  );
}

export default App;
